<template>
    <span class="label" :class="statusClass">
        <img :src="statusIcon" class="label__icon" />

        {{ trans('domain.whois.private-status.' + status) }}
    </span>
</template>

<script>
export default {
    props: {
        status: {
            type: String,
            required: true
        }
    },
    computed: {
        /**
         * Status class.
         *
         * @return {string}
         */
        statusClass() {
            return 'label--' + this.status;
        },
        /**
         * Icon source.
         *
         * @return {string}
         */
        statusIcon() {
            return require('../assets/label-icons/' + this.status + '.svg');
        }
    }
};
</script>
